/** Minimal raffle shape for lobby phase / pool helpers (storefront room). */
export interface RaffleLobbySlice {
  mode: "SINGLE" | "LOBBY";
  status: string;
  entryOpensAt: string;
  entryClosesAt: string;
  items: { id: string; status: string; entryOpensAt: string | null; entryClosesAt: string | null }[];
}

export function isGlobalEntryOpen(raffle: RaffleLobbySlice, now = Date.now()) {
  return (
    raffle.status === "OPEN" &&
    now >= new Date(raffle.entryOpensAt).getTime() &&
    now <= new Date(raffle.entryClosesAt).getTime()
  );
}

/** Global entry closed but worker has not yet moved raffle to DRAWING. */
export function isLobbyStarting(raffle: RaffleLobbySlice, now = Date.now()) {
  return (
    raffle.mode === "LOBBY" &&
    raffle.status === "OPEN" &&
    now > new Date(raffle.entryClosesAt).getTime()
  );
}

export function isLobbyItemWindowOpen(
  item: { status: string; entryOpensAt: string | null; entryClosesAt: string | null },
  now = Date.now(),
) {
  if (item.status !== "ENTRY_OPEN" || !item.entryOpensAt || !item.entryClosesAt) return false;
  const opens = new Date(item.entryOpensAt).getTime();
  const closes = new Date(item.entryClosesAt).getTime();
  return now >= opens && now < closes;
}
